import * as React from "react";
import { ProductDetailDisclaimer } from "./ProductDetailDisclaimer.js";
import { useCmsData } from "../../../../../../context/context/CmsContext.js";
const ProductDetailDisclaimerContainer = ({ className }) => {
  const { disclaimer } = useCmsData();
  if (!disclaimer) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ProductDetailDisclaimer, { className, disclaimer });
};
export {
  ProductDetailDisclaimerContainer
};
//# sourceMappingURL=ProductDetailDisclaimerContainer.js.map
